module.exports = __webpack_public_path__ + "img/me_L.14e3d402.jpg";